module.exports = __webpack_public_path__ + "media/images/game_icon/vi/BC4057-82aac580f2e6583d6c1da969c6ec47e3.png";